import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import {RouteTransferTypeValuesType} from "@Route/features/transportType/types/routeTransferType.type";
import filterDuplicates from "@Array/filterDuplicates";
import {StationType} from "@SearchResults/types/station/Station.type";
import RouteType from "@Route/types/Route.type";

type GetUniqueStationsProps = {
    searchData: SearchResultsRtkQueryResponseType,
    tab: RouteTransferTypeValuesType,
    stations: 'departureStation' | 'destinationStation',
    filteredRoutes?: RouteType[] // Optional filtered routes to use instead of raw routes
}
export default function getUniqueStationsForActiveTab(props: GetUniqueStationsProps): StationType[] {
    // Use filtered routes if provided, otherwise fall back to raw routes
    const routesToUse = props.filteredRoutes || props.searchData.result.singleRoutes[props.tab]
    const stations = routesToUse.map((route) => route.travelInfo[props.stations]);

    const uniqueStations = filterDuplicates(stations, 'id');

    return uniqueStations;
}